/* --------------------------------------------------------------------------------------
   users.component.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const usersComponent  = {
    template: require('./users.html'),
    controller: 'usersCtrl',
    controllerAs: 'vm',
    bindings: {
      newUser: '&',
      login: '&'
    }
}

export class usersCtrl {
  /*@ngInject*/
  constructor(appSettings, commonService, userService, appService, $timeout, $translate) {
    this.appSettings = appSettings
    this.commonService = commonService
    this.userService = userService
    this.$timeout = $timeout
    this.$translate = $translate
  }
  $onInit () {
    this.commonService.setDefaultBackground()
    this.users = this.userService.getUsers()
    this.version = this.appSettings.version
    this.language = this.$translate.use()
    this.$timeout(() => this.language = this.$translate.use())
    this.$timeout(() => $('a').contents().unwrap(), 1000)
  }
  privacyStatementClosed() {
    this.$timeout(() => this.privacyStatement = false)
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/components/users.component.js